/**
 * 옛 WebView 호환 폴리필 — main.tsx가 가장 먼저 불러온다.
 *
 * Vite 기본 타깃은 문법만 Chrome 87 수준으로 바꿔 주고, ES2022에 더해진 **내장 메서드**는
 * 그대로 남긴다. Android System WebView를 2021년 중반 이후 업데이트하지 않은 기기(Chrome 90대)는
 * `Array.prototype.at`이 없어 앨범·신체 성장 화면이 통째로 죽었다(Sentry: "k.at is not a function").
 * 코드에서 `.at()`을 걷어냈지만, 의존 라이브러리가 쓸 수도 있으므로 여기서 한 번 채워 둔다.
 * 새 ES2022+ 메서드를 쓰게 되면 같은 방식으로 여기에 더한다.
 */

function at<T>(this: ArrayLike<T> | string, index: number): T | string | undefined {
  const length = this.length;
  let n = Math.trunc(index) || 0;
  if (n < 0) n += length;
  if (n < 0 || n >= length) return undefined;
  return this[n];
}

export function installPolyfills(): void {
  if (typeof Array.prototype.at !== 'function') {
    Object.defineProperty(Array.prototype, 'at', { value: at, writable: true, configurable: true });
  }
  if (typeof String.prototype.at !== 'function') {
    Object.defineProperty(String.prototype, 'at', { value: at, writable: true, configurable: true });
  }
}

installPolyfills();
